import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@hta/auth';
import { of } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
            // If the user is not logged in, redirect to the sign-in page
    let isloggedIn = inject(AuthService).isAuthenticated();
   // debugger;
    if(isloggedIn === false) {
        // If the user is not logged in, redirect to the sign-in page   
        const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
        const urlTree = router.parseUrl(`sign-in?${redirectURL}`);  
        return of(urlTree);
    }
    return of(true);
};
